import axios from 'axios'
import {
  getCookie
} from '@/uitls/index'

/* global interceptor */
/* interception on request */
axios.interceptors.request.use((config) => {
  // fetch token from cookie when interceptorDisabled is false
  if (!config.interceptorDisabled) {
    let token = getCookie('accesstoken')
    if (token) {
      config.headers['Authorization'] = token
    }
  }
  return config
})

/* interception on response */
axios.interceptors.response.use(
  response => {
    const {
      config,
      data: {
        code
      }
    } = response;
    // disable global handling when interceptorDisabled is true
    // 1009: accessToken is null
    // 1008: accessToken is invalid
    if (!config.interceptorDisabled && (code == 1009 || code == 1008)) {
      window.$eventHub.$emit('sendUpdate', response)
      window.location.href = window.location.origin + '/#/login'
    }
    return response
  },
  error => {
    console.log(error)
  })

export default axios



// WEBPACK FOOTER //
// ./src/axios/axios.js